import React from 'react';
import { cn } from './cn';

/** shadcn/ui Card ailesi. */

type DivProps = React.HTMLAttributes<HTMLDivElement>;

export const Card: React.FC<DivProps> = ({ className, ...props }) => (
  <div
    className={cn('flex flex-col gap-6 rounded-xl border border-border bg-card py-6 text-card-foreground shadow-xs', className)}
    {...props}
  />
);

export const CardHeader: React.FC<DivProps> = ({ className, ...props }) => (
  <div
    className={cn('grid auto-rows-min items-start gap-1.5 px-6 has-[[data-slot=card-action]]:grid-cols-[1fr_auto]', className)}
    {...props}
  />
);

export const CardTitle: React.FC<React.HTMLAttributes<HTMLHeadingElement>> = ({ className, ...props }) => (
  <h2 className={cn('font-semibold leading-none', className)} {...props} />
);

export const CardDescription: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = ({ className, ...props }) => (
  <p className={cn('text-sm text-muted-foreground', className)} {...props} />
);

/** Başlığın sağındaki alan (düğme, rozet). */
export const CardContent: React.FC<DivProps> = ({ className, ...props }) => (
  <div className={cn('px-6', className)} {...props} />
);
